import { handleError } from './apiUtils'
import { getConfigurationAsync, xKMSClient } from './httpMethods'
import { UserPermissionsApi, UserPermissionsResponseDto } from './kmsapiclient'

/**
 * Retrieves the user permissions.
 *
 * @returns A promise that resolves to a `UserPermissionsResponseDto` object.
 */
export async function getUserPermissionsAsync(): Promise<UserPermissionsResponseDto> {
  try {
    const userPermissionsApi = new UserPermissionsApi(getConfigurationAsync())
    const response = (await userPermissionsApi.getUserPermissions(xKMSClient))
      .data
    return response
  } catch (error) {
    handleError(error)
    return Promise.reject(error)
  }
}
